import { render, staticRenderFns } from "./create-allocation.vue?vue&type=template&id=3aad21eb&"
import script from "./create-allocation.vue?vue&type=script&lang=js&"
export * from "./create-allocation.vue?vue&type=script&lang=js&"
import style0 from "./create-allocation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports